import { render, staticRenderFns } from "./FrontendView.vue?vue&type=template&id=00a5ee51&scoped=true&"
import script from "./FrontendView.vue?vue&type=script&lang=js&"
export * from "./FrontendView.vue?vue&type=script&lang=js&"
import style0 from "./FrontendView.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./FrontendView.vue?vue&type=style&index=1&id=00a5ee51&lang=scss&scoped=true&"
import style2 from "./FrontendView.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a5ee51",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMain } from 'vuetify/lib/components/VMain';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VBtn,VIcon,VImg,VList,VListItemTitle,VMain,VMenu,VSelect,VSpacer,VToolbarTitle})
